import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBackendApi from '../../../hooks/useBackendApi';
import GradientCircularProgressContainer from '../../../components/common/GradientCircularProgressContainer';
import { useThemeContext } from '../../../contexts/ThemeContext.js';

const PipedriveDisconnect: React.FC = () => {
  const navigate = useNavigate();
  const { apiFetchRequest } = useBackendApi();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { isMembershipDataReady } = useThemeContext();

  useEffect(() => {
    const disconnectPipedrive = async () => {
      try {
        if (!isMembershipDataReady) {
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const slackId = urlParams.get('slack_id');

        const response = await apiFetchRequest({
          endpoint: '/api/angie/auth/pipedrive/connection',
          method: 'DELETE',
          body: { user_id: slackId },
        });

        if (response && !response.isError) {
          setStatus('success');
        } else {
          setStatus('error');
          setErrorMessage(response?.body?.message || 'Failed to disconnect from backend.');
        }
      } catch (err: unknown) {
        console.error(err);
        setStatus('error');
        setErrorMessage(err instanceof Error ? err.message : 'An unexpected error occurred.');
      }
    };

    disconnectPipedrive();
  }, [apiFetchRequest, isMembershipDataReady]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {status === 'loading' && <GradientCircularProgressContainer loadingMessage="Disconnecting Pipedrive..." />}
      {status === 'success' && (
        <>
          <h2 className="text-2xl font-bold text-green-600 mb-4">You have successfully disconnected Pipedrive.</h2>
          <button onClick={() => navigate('/')} className="px-6 py-2 bg-blue-600 text-white rounded">
            Return to Dashboard
          </button>
        </>
      )}
      {status === 'error' && (
        <>
          <h2 className="text-2xl font-bold text-red-600 mb-4">{errorMessage || 'Error disconnecting Pipedrive.'}</h2>
          <button onClick={() => navigate('/')} className="px-6 py-2 bg-gray-600 text-white rounded">
            Go Back
          </button>
        </>
      )}
    </div>
  );
};

export default PipedriveDisconnect;
